import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getReportSession = async (queries) => {
  const { data } = await SigliveServiceV2({ method: 'GET', url: `/reporting/session?${queries}` });

  return data?.data;
};

export default getReportSession;
